import { render, staticRenderFns } from "./income.vue?vue&type=template&id=c3578026&scoped=true&"
import script from "./income.vue?vue&type=script&lang=js&"
export * from "./income.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3578026",
  null
  
)

export default component.exports